import React, { FC, SVGAttributes } from 'react'
import { SizeProps, SpaceProps, size, space } from 'styled-system'
import styled from 'styled-components'
import { breakpoints } from '../Theme'
import openNav from './open-nav'
import cross from './cross'
import search from './search'
import profile from './profile'
import heart from './heart'

import shoppingBag from './shopping-bag'
import chevronDown from './chevron-down'
import chevronUp from './chevron-up'
import chevronLeft from './chevron-left'
import chevronRight from './chevron-right'
import chevronDownSmall from './chevron-down-small'
import chevronUpSmall from './chevron-up-small'
import chevronLeftSmall from './chevron-left-small'
import chevronRightSmall from './chevron-right-small'
import arrowLeft from './arrow-left'
import arrowRight from './arrow-right'
import heartFilled from './heart-filled'
import plus from './plus'
import settings from './settings'
import settingsAlt from './settings-alt'
import bullet from './bullet'
import check from './check'
import play from './play'
import checkCircle from './check-circle'
import wheelchair from './wheelchair'
import wifi from './wifi'
import globe from './globe'
import sliderArrowLeft from './slider-arrow-left'
import sliderArrowRight from './slider-arrow-right'
import freeDelivery from './free-delivery'
import personalAdvice from './personal_advice'
import freeReturns from './free-returns'
import alwaysInsured from './always-insured'
import calendar from './calendar'
import trashCan from './trash-can'
import lock from './lock'
import exclamation from './exclamation'
import clock from './clock'
import peopleDouble from './people-double'

export const icons = {
  'open-nav': openNav,
  calendar,
  cross,
  search,
  profile,
  heart,
  'shopping-bag': shoppingBag,
  'chevron-down': chevronDown,
  'chevron-up': chevronUp,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'chevron-down-small': chevronDownSmall,
  'chevron-up-small': chevronUpSmall,
  'chevron-left-small': chevronLeftSmall,
  'chevron-right-small': chevronRightSmall,
  'arrow-left': arrowLeft,
  'arrow-right': arrowRight,
  'heart-filled': heartFilled,
  plus,
  settings,
  'settings-alt': settingsAlt,
  bullet,
  check,
  play,
  'check-circle': checkCircle,
  wheelchair,
  wifi,
  globe,
  'slider-arrow-left': sliderArrowLeft,
  'slider-arrow-right': sliderArrowRight,
  'free-delivery': freeDelivery,
  'personal-advice': personalAdvice,
  'free-returns': freeReturns,
  'always-insured': alwaysInsured,
  'trash-can': trashCan,
  lock,
  exclamation,
  'people-double': peopleDouble,
  clock
}

export type Icons = typeof icons

type SvgProps = SizeProps & SpaceProps

const Svg = styled.svg<SvgProps>`
  ${size};
  ${space};

  .dynamic-stroke-width {
    stroke-width: 1px;
    @media screen and (min-width: ${breakpoints.small}) {
      stroke-width: 2px;
    }
  }
  .show-on-small {
    display: initial;
    @media screen and (min-width: ${breakpoints.small}) {
      display: none;
    }
  }
  .hide-on-small {
    display: none;
    @media screen and (min-width: ${breakpoints.small}) {
      display: initial;
    }
  }
`

type IconProps = Omit<SVGAttributes<SVGElement>, 'display'> &
  SvgProps & {
    icon: keyof Icons
  }

export const Icon: FC<IconProps> = ({ icon, size = [32, 32, 40], ...rest }) => {
  return icons[icon] ? (
    <Svg viewBox="0 0 40 40" size={size} {...rest}>
      {icons[icon]}
    </Svg>
  ) : null
}

export default Icon
